
const _r: readonly (readonly [string, any])[] = [
  [ "page", pageRelation],
  [ "media", mediaRelation],
  ["entity", entityRelation ]
]

const relations: Map<string, any> = new Map([..._r])

type Relation = {
    relationTo: string
    value: number|any
}

export function urlFromRelation(relation: Relation, locale: string = ''): string {
  const fn = relations.get(relation.relationTo)
  if( fn ) return fn(relation, locale)
  return "#"
}


export function urlFromSlug(slug: string, locale: string = '') {
  return `${locale}/${slug}`
}

function entityRelation(relation: Relation) {
  return `/osobnosti/${relation.value.id}`
}

function pageRelation(relation: Relation, locale: string = '') {
  return `/${locale}/${relation.value.slug}`
}

function mediaRelation(relation: Relation) {
  return `${relation.value.url}`
}


export function titleFromRelation(relation: Relation, locale: string = ''): string {
  return relation.value.title
}